// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planning-selection-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.planning-selection-filters {
  display: flex;
  flex-direction: row;
  align-items: end;
  gap: 40px;
}
.planning-selection-filters .BaSe--input {
  margin-bottom: 0;
}
.planning-selection-filters .BaSe--input input {
  height: 32px !important;
  font-size: 13px !important;
}
.planning-selection-filters .BaSe--input button {
  width: 24px;
  min-width: 24px;
  height: 32px;
  min-height: 32px;
  background-color: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
  cursor: default;
}
@media (min-width: 768px) {
  .planning-selection-filters .BaSe--input {
    max-width: unset;
  }
}
.planning-selection-filters .BaSe--select input {
  width: 100%;
  height: 32px !important;
  font-size: 13px !important;
}
.planning-selection-filters .BaSe--select label, .planning-selection-filters .BaSe--select ul {
  font-size: 13px;
  line-height: 1;
  color: var(--sebrae-gray);
}
.planning-selection-grid {
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-auto-flow: column;
  grid-auto-columns: 595px;
  column-gap: 40px;
  row-gap: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
}
.planning-selection-grid .BaSe--checkbox input {
  width: 15px;
  height: 15px;
  top: 4px;
  left: 2px;
}
.planning-selection-grid .BaSe--checkbox div[shape=square] {
  width: 18px;
  height: 18px;
}
.planning-selection-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 595px;
  height: 69px;
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 1px 4px 0px rgba(20, 46, 82, 0.2);
  overflow: hidden;
}
.planning-selection-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(45deg, #84F4BC 0%, #40BBFF 100%);
  border-radius: 8px 0 0 8px;
}
.planning-selection-card-text h4 {
  font-weight: bold;
}
.planning-selection-card-text small {
  font-size: 13px;
  font-weight: 400;
}

.indicators-selection-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.indicators-selection-container .BaSe--checkbox input {
  width: 15px;
  height: 15px;
  top: 4px;
  left: 2px;
}
.indicators-selection-container .BaSe--checkbox div[shape=square] {
  width: 18px;
  height: 18px;
}
.indicators-selection-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-flow: row;
  gap: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 12px;
}
@media (max-width: 1869px) {
  .indicators-selection-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
.indicators-selection-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: white;
  border-radius: 8px;
  z-index: 2;
  width: 394px;
  height: 96px;
  padding: 16px;
}
.indicators-selection-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 8px;
  padding: 1px;
  background: linear-gradient(45deg, #CD5BE8 0%, #FFABAB 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
}
.indicators-selection-card .BaSe--checkbox {
  width: 18px;
  margin-bottom: 36px;
}
.indicators-selection-card-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.indicators-selection-card-text p {
  font-weight: bold;
  color: var(--sebrae-blue-6);
}
.indicators-selection-card-text span {
  margin-left: 7px;
  font-size: 13px;
}

.lab-results-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  z-index: 9999;
  overflow-y: auto;
  padding: 24px 112px 80px;
}
.lab-results-container .information-box {
  gap: 8px;
  display: flex;
  padding: 16px;
  border-radius: 4px;
  flex-direction: column;
  background-color: #ebe8ff;
  max-height: 1000px;
  overflow: hidden;
  transition: max-height 0.4s ease, padding 0.4s ease, opacity 0.3s ease, min-height 0.4s ease;
  margin-bottom: 32px;
}
.lab-results-container .information-box:not(.collapsed) {
  min-height: 128px;
}
.lab-results-container .information-box.collapsed {
  max-height: 0;
  min-height: 0;
  padding: 0 16px;
  opacity: 0;
  margin-bottom: 0;
}
.lab-results-container .information-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.lab-results-container .information-box-header svg {
  cursor: pointer;
  transition: transform 0.2s ease;
}
.lab-results-container .information-box-header svg:hover {
  transform: scale(1.2);
}
.lab-results-container .information-box-texts {
  gap: 8px;
  display: flex;
  flex-direction: column;
  transition: opacity 0.3s ease;
}
.lab-results-container .information-box-texts p {
  font-size: 13px;
  font-weight: 400;
  font-style: normal;
}
.lab-results-container .information-box-texts p span {
  font-weight: 700;
}
.lab-results-container .information-box-footer {
  display: flex;
  justify-content: flex-end;
}
.lab-results-container .information-box-footer button > span {
  font-weight: bold;
}
.lab-results-container .information-box.collapsed .lab-results-container .information-box-texts {
  opacity: 0;
}
.lab-results-container .information-box .BaSe--checkbox input {
  width: 15px;
  height: 15px;
  top: 4px;
  left: 2px;
}
.lab-results-container .information-box .BaSe--checkbox div[shape=circle] {
  width: 18px;
  height: 18px;
}
.lab-results-container .information-box h4 {
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  color: var(--sebrae-blue-6);
}
.lab-results-container .information-box small {
  font-size: 13px;
}
.lab-results-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.indicator-bar-container, .indicator-line-container {
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
}
.indicator-bar-container .BaSe--select input, .indicator-line-container .BaSe--select input {
  width: 100%;
  height: 32px !important;
  font-size: 13px !important;
}
.indicator-bar-container .BaSe--select label, .indicator-bar-container .BaSe--select ul, .indicator-line-container .BaSe--select label, .indicator-line-container .BaSe--select ul {
  font-size: 13px;
  line-height: 1;
  color: var(--sebrae-gray);
}
.indicator-bar-container-header, .indicator-line-container-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.indicator-bar-container-header h3, .indicator-line-container-header h3 {
  font-family: Campuni;
  font-size: 27px;
  line-height: 100%;
  color: var(--sebrae-blue-6);
  font-weight: bold;
}
.indicator-bar-container-header div img, .indicator-line-container-header div img {
  width: 20px;
  height: 20px;
}
.indicator-bar-container-header-content, .indicator-line-container-header-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
}
.indicator-bar-container-header-content div, .indicator-line-container-header-content div {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.indicator-bar-container .line, .indicator-line-container .line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.lab-modal-edit-container .header-content p {
  color: var(--sebrae-gray) !important;
}
.lab-modal-edit-container .lab-variations {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.lab-modal-edit-container .lab-variations > p {
  font-size: 13px;
  color: var(--sebrae-gray);
  margin: 0 0 8px;
}
.lab-modal-edit-container .lab-variations .custom-input-range {
  box-shadow: none;
  padding: 0;
  background: transparent;
}
.lab-modal-edit-container .lab-variations .custom-input-range.has-value {
  background: transparent;
}
.lab-modal-edit-container .lab-variations .custom-input-range.has-value .input-range {
  color: var(--sebrae-blue);
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range label {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 24px;
  color: var(--sebrae-gray);
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range__wrapper-input {
  padding-top: 40px;
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range__wrapper-input small {
  font-size: 11px;
  font-style: italic;
  color: var(--sebrae-gray);
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range__track {
  position: relative;
  width: 100%;
  height: 4px;
  border-radius: 10px;
  background: var(--sebrae-light-gray4);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range__fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 10px;
  background: var(--sebrae-blue);
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range__thumb {
  position: absolute;
  top: 50%;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--sebrae-blue);
  transform: translate(-50%, -50%);
  cursor: grab;
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range__thumb:active {
  cursor: grabbing;
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range__tooltip {
  height: 21px;
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #324D5B;
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
  padding: 4px 8px;
  border-radius: 6px;
  white-space: nowrap;
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range__tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #324D5B;
}
.lab-modal-edit-container .lab-variations .custom-input-range .input-range .value-container {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}
.lab-modal-edit-container .step--info {
  display: none;
}
.lab-modal-edit-container .total-investment .BaSe--grid {
  gap: 16px !important;
}
.lab-modal-edit-container .deadline-select-wrapper {
  max-width: unset;
  height: 61px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.lab-modal-edit-container .deadline-select-wrapper .BaSe--select img {
  right: -40px;
}
.lab-modal-edit-container .deadline-select-wrapper .BaSe--select div[role=menu] {
  width: 300px;
}
.lab-modal-edit-container .deadline-select-wrapper .BaSe--select input {
  width: 300px;
}
.lab-modal-edit-container .deadline-select-wrapper .BaSe--input {
  margin-top: 0;
}
.lab-modal-edit-container .deadline-select-wrapper .icon-wrapper img {
  width: 22px;
  height: 22px;
}
.lab-modal-edit-container .BaSe--input {
  margin-bottom: 0;
}

.lab-modal-edit-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 24px 32px 32px;
  border-top: 1px solid var(--sebrae-light-gray4);
  margin-right: -16px;
  margin-left: -16px;
}
.lab-modal-edit-footer-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.lab-modal-edit-footer-content p {
  height: 16px;
  margin-bottom: 8px;
  font-weight: bold;
  color: var(--sebrae-red-3);
}`, "",{"version":3,"sources":["webpack://./src/components/comparison-lab/steps/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAGM;EACE,uBAAA;EACA,0BAAA;AADR;AAIM;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAFR;AAKM;EApBF;IAqBI,gBAAA;EAFN;AACF;AAMM;EACE,WAAA;EACA,uBAAA;EACA,0BAAA;AAJR;AAMM;EACE,eAAA;EACA,cAAA;EACA,yBAAA;AAJR;AASE;EACE,aAAA;EACA,kCAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAPJ;AAUM;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AARR;AAUM;EACE,WAAA;EACA,YAAA;AARR;AAaE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,iDAAA;EACA,gBAAA;AAXJ;AAaI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,4DAAA;EACA,0BAAA;AAXN;AAeM;EACE,iBAAA;AAbR;AAeM;EACE,eAAA;EACA,gBAAA;AAbR;;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAjBJ;AAoBM;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AAlBR;AAoBM;EACE,WAAA;EACA,YAAA;AAlBR;AAwBE;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAtBJ;AAwBI;EATF;IAUI,qCAAA;EArBJ;AACF;AAwBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AAtBJ;AAwBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,4DAAA;EACA,8EACE;EAGF,uBAAA;EACA,oBAAA;AAxBN;AA2BI;EACE,WAAA;EACA,mBAAA;AAzBN;AA4BI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA1BN;AA4BM;EACE,iBAAA;EACA,2BAAA;AA1BR;AA4BM;EACE,gBAAA;EACA,eAAA;AA1BR;;AAiCE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;AA9BJ;AAgCI;EACE,QAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4FAAA;EACA,mBAAA;AA9BN;AAgCM;EACE,iBAAA;AA9BR;AAiCM;EACE,aAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AA/BR;AAkCM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAhCR;AAkCQ;EACE,eAAA;EACA,+BAAA;AAhCV;AAkCU;EACE,qBAAA;AAhCZ;AAqCM;EACE,QAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AAnCR;AAqCQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAnCV;AAqCU;EACE,gBAAA;AAnCZ;AAwCM;EACE,aAAA;EACA,yBAAA;AAtCR;AAwCQ;EACE,iBAAA;AAtCV;AA0CM;EACE,UAAA;AAxCR;AA4CQ;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AA1CV;AA4CQ;EACE,WAAA;EACA,YAAA;AA1CV;AA8CM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AA5CR;AA+CM;EACE,eAAA;AA7CR;AAkDE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhDJ;;AAqDE;EACE,aAAA;EACA,kBAAA;EACA,6CAAA;AAlDJ;AAqDM;EACE,WAAA;EACA,uBAAA;EACA,0BAAA;AAnDR;AAqDM;EACE,eAAA;EACA,cAAA;EACA,yBAAA;AAnDR;AAuDI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AArDN;AAuDM;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,iBAAA;AArDR;AAyDQ;EACE,WAAA;EACA,YAAA;AAvDV;AA2DM;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,QAAA;AAzDR;AA2DQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AAzDV;AA8DI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA5DN;;AAmEI;EACE,oCAAA;AAhEN;AAoEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAlEJ;AAoEI;EACE,eAAA;EACA,yBAAA;EACA,eAAA;AAlEN;AAqEI;EACE,gBAAA;EACA,UAAA;EACA,uBAAA;AAnEN;AAqEM;EACE,uBAAA;AAnER;AAqEQ;EACE,yBAAA;AAnEV;AAwEQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAtEV;AAyEQ;EACE,iBAAA;AAvEV;AAyEU;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;AAvEZ;AA2EQ;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAzEV;AA4EQ;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;AA1EV;AA6EQ;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,gCAAA;EACA,YAAA;AA3EV;AA6EU;EACE,gBAAA;AA3EZ;AA+EQ;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA7EV;AA+EU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;AA7EZ;AAiFQ;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AA/EV;AAqFE;EACE,aAAA;AAnFJ;AAuFI;EACE,oBAAA;AArFN;AAyFE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAvFJ;AA0FM;EACE,YAAA;AAxFR;AA0FM;EACE,YAAA;AAxFR;AA0FM;EACE,YAAA;AAxFR;AA4FI;EACE,aAAA;AA1FN;AA8FM;EACE,WAAA;EACA,YAAA;AA5FR;AAiGE;EACE,gBAAA;AA/FJ;;AAoGA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AAjGF;AAmGE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAjGJ;AAkGI;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;AAhGN","sourcesContent":[".planning-selection {\n  &-container {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  &-filters {\n    display: flex;\n    flex-direction: row;\n    align-items: end;\n    gap: 40px;\n\n    .BaSe--input {\n      margin-bottom: 0;\n\n      input {\n        height: 32px !important;\n        font-size: 13px !important;\n      }\n\n      button {\n        width: 24px;\n        min-width: 24px;\n        height: 32px;\n        min-height: 32px;\n        background-color: transparent;\n        box-shadow: none;\n        border: none;\n        padding: 0;\n        cursor: default;\n      }\n\n      @media (min-width: 768px) {\n        max-width: unset;\n      }\n    }\n\n    .BaSe--select {\n      input {\n        width: 100%;\n        height: 32px !important;\n        font-size: 13px !important;\n      }\n      label, ul {\n        font-size: 13px;\n        line-height: 1;\n        color: var(--sebrae-gray);\n      }\n    }\n  }\n\n  &-grid {\n    display: grid;\n    grid-template-rows: repeat(4, 1fr);\n    grid-auto-flow: column;\n    grid-auto-columns: 595px;\n    column-gap: 40px;\n    row-gap: 24px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding-bottom: 8px;\n\n    .BaSe--checkbox {\n      input {\n        width: 15px;\n        height: 15px;\n        top: 4px;\n        left: 2px;\n      }\n      div[shape=\"square\"] {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  &-card {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 595px;\n    height: 69px;\n    background-color: white;\n    border-radius: 8px;\n    padding: 16px;\n    box-shadow: 0px 1px 4px 0px rgba(20, 46, 82, 0.2);\n    overflow: hidden;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 4px;\n      height: 100%;\n      background: linear-gradient(45deg, #84F4BC 0%, #40BBFF 100%);\n      border-radius: 8px 0 0 8px;\n    }\n\n    &-text {\n      h4 {\n        font-weight: bold;\n      }\n      small {\n        font-size: 13px;\n        font-weight: 400;\n      }\n    }\n  }\n}\n\n.indicators-selection {\n  &-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    .BaSe--checkbox {\n      input {\n        width: 15px;\n        height: 15px;\n        top: 4px;\n        left: 2px;\n      }\n      div[shape=\"square\"] {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n\n  &-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-auto-flow: row;\n    gap: 24px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding-bottom: 12px;\n\n    @media (max-width: 1869px) {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n\n  &-card {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background-color: white;\n    border-radius: 8px;\n    z-index: 2;\n    width: 394px;\n    height: 96px;\n    padding: 16px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      inset: 0;\n      border-radius: 8px;\n      padding: 1px;\n      background: linear-gradient(45deg, #CD5BE8 0%, #FFABAB 100%);\n      -webkit-mask: \n        linear-gradient(#fff 0 0) content-box, \n        linear-gradient(#fff 0 0);\n      -webkit-mask-composite: xor;\n      mask-composite: exclude;\n      pointer-events: none;\n    }\n\n    .BaSe--checkbox {\n      width: 18px;\n      margin-bottom: 36px;\n    }\n\n    &-text {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      p {\n        font-weight: bold;\n        color: var(--sebrae-blue-6);\n      }\n      span {\n        margin-left: 7px;\n        font-size: 13px;\n      }\n    }\n  }\n}\n\n.lab-results {\n  &-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: #ffffff;\n    z-index: 9999;\n    overflow-y: auto;\n    padding: 24px 112px 80px;\n\n    .information-box {\n      gap: 8px;\n      display: flex;\n      padding: 16px;\n      border-radius: 4px;\n      flex-direction: column;\n      background-color: #ebe8ff;\n      max-height: 1000px;\n      overflow: hidden;\n      transition: max-height 0.4s ease, padding 0.4s ease, opacity 0.3s ease, min-height 0.4s ease;\n      margin-bottom: 32px;\n\n      &:not(.collapsed) {\n        min-height: 128px;\n      }\n\n      &.collapsed {\n        max-height: 0;\n        min-height: 0;\n        padding: 0 16px;\n        opacity: 0;\n        margin-bottom: 0;\n      }\n\n      &-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        flex-shrink: 0;\n\n        svg {\n          cursor: pointer;\n          transition: transform 0.2s ease;\n\n          &:hover {\n            transform: scale(1.2);\n          }\n        }\n      }\n\n      &-texts {\n        gap: 8px;\n        display: flex;\n        flex-direction: column;\n        transition: opacity 0.3s ease;\n\n        p {\n          font-size: 13px;\n          font-weight: 400;\n          font-style: normal;\n\n          span {\n            font-weight: 700;\n          }\n        }\n      }\n\n      &-footer {\n        display: flex;\n        justify-content: flex-end;\n\n        button > span {\n          font-weight: bold;\n        }\n      }\n\n      &.collapsed &-texts {\n        opacity: 0;\n      }\n\n      .BaSe--checkbox {\n        input {\n          width: 15px;\n          height: 15px;\n          top: 4px;\n          left: 2px;\n        }\n        div[shape=\"circle\"] {\n          width: 18px;\n          height: 18px;\n        }\n      }\n\n      h4 {\n        font-size: 16px;\n        font-weight: 700;\n        font-style: normal;\n        color: var(--sebrae-blue-6);\n      }\n\n      small {\n        font-size: 13px;\n      }\n    }\n  }\n\n  &-content {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n}\n\n.indicator-bar, .indicator-line {\n  &-container {\n    padding: 16px;\n    border-radius: 8px;\n    box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.20);\n\n    .BaSe--select {\n      input {\n        width: 100%;\n        height: 32px !important;\n        font-size: 13px !important;\n      }\n      label, ul {\n        font-size: 13px;\n        line-height: 1;\n        color: var(--sebrae-gray);\n      }\n    }\n\n    &-header {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 4px;\n\n      h3 {\n        font-family: Campuni;\n        font-size: 27px;\n        line-height: 100%;\n        color: var(--sebrae-blue-6);\n        font-weight: bold;\n      }\n\n      div {\n        img {\n          width: 20px;\n          height: 20px;\n        }\n      }\n\n      &-content {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        gap: 6px;\n\n        div {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: 8px;\n        }\n      }\n    }\n\n    .line {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n    }\n  }\n}\n\n.lab-modal-edit-container {\n  .header-content {\n    p {\n      color: var(--sebrae-gray) !important;\n    }\n  }\n\n  .lab-variations {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    > p {\n      font-size: 13px;\n      color: var(--sebrae-gray);\n      margin: 0 0 8px;\n    }\n\n    .custom-input-range {\n      box-shadow: none;\n      padding: 0;\n      background: transparent;\n\n      &.has-value {\n        background: transparent;\n\n        .input-range {\n          color: var(--sebrae-blue);\n        }\n      }\n\n      .input-range {\n        label {\n          font-size: 14px;\n          font-weight: 400;\n          margin-bottom: 24px;\n          color: var(--sebrae-gray);\n        }\n\n        &__wrapper-input {\n          padding-top: 40px;\n\n          small {\n            font-size: 11px;\n            font-style: italic;\n            color: var(--sebrae-gray);\n          }\n        }\n\n        &__track {\n          position: relative;\n          width: 100%;\n          height: 4px;\n          border-radius: 10px;\n          background: var(--sebrae-light-gray4);\n          cursor: pointer;\n          user-select: none;\n        }\n\n        &__fill {\n          position: absolute;\n          left: 0;\n          top: 0;\n          height: 100%;\n          border-radius: 10px;\n          background: var(--sebrae-blue);\n        }\n\n        &__thumb {\n          position: absolute;\n          top: 50%;\n          width: 16px;\n          height: 16px;\n          border-radius: 50%;\n          background-color: var(--sebrae-blue);\n          transform: translate(-50%, -50%);\n          cursor: grab;\n\n          &:active {\n            cursor: grabbing;\n          }\n        }\n\n        &__tooltip {\n          height: 21px;\n          position: absolute;\n          bottom: calc(100% + 10px);\n          left: 50%;\n          transform: translateX(-50%);\n          background-color: #324D5B;\n          color: #ffffff;\n          font-size: 12px;\n          font-weight: 400;\n          padding: 4px 8px;\n          border-radius: 6px;\n          white-space: nowrap;\n\n          &::after {\n            content: '';\n            position: absolute;\n            top: 100%;\n            left: 50%;\n            transform: translateX(-50%);\n            border: 5px solid transparent;\n            border-top-color: #324D5B;\n          }\n        }\n\n        .value-container {\n          display: flex;\n          justify-content: space-between;\n          margin-top: 6px;\n        }\n      }\n    }\n  }\n\n  .step--info {\n    display: none;\n  }\n\n  .total-investment {\n    .BaSe--grid {\n      gap: 16px !important;\n    }\n  }\n\n  .deadline-select-wrapper {\n    max-width: unset;\n    height: 61px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .BaSe--select {\n      img {\n        right: -40px;\n      }\n      div[role=\"menu\"] {\n        width: 300px;\n      }\n      input {\n        width: 300px;\n      }\n    }\n\n    .BaSe--input {\n      margin-top: 0;\n    }\n\n    .icon-wrapper {\n      img {\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n\n  .BaSe--input {\n    margin-bottom: 0;\n  }\n\n}\n\n.lab-modal-edit-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding: 24px 32px 32px;\n  border-top: 1px solid var(--sebrae-light-gray4);\n  margin-right: -16px;\n  margin-left: -16px;\n\n  &-content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    p {\n      height: 16px;\n      margin-bottom: 8px;\n      font-weight: bold;\n      color: var(--sebrae-red-3);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
